/* @flow */
import * as storeConnect from "./utils/storeConnect";

// Register stores to be used with storeConnect
import CustomerStore from "./stores/CustomerStore";
storeConnect.registerStore("CustomerStore", CustomerStore);
import { SessionStore } from "./uidispatcherapi/SessionStore";
storeConnect.registerStore("SessionStore", SessionStore);
import CatalogueStore from "./stores/CatalogueStore";
storeConnect.registerStore("CatalogueStore", CatalogueStore);
import { MerchantEvaluationsStore } from "./stores/marketplace/MerchantEvaluationsStore";
storeConnect.registerStore("MerchantEvaluationsStore", MerchantEvaluationsStore);
import { MerchantInformationStore } from "./stores/marketplace/MerchantInformationStore";
storeConnect.registerStore("MerchantInformationStore", MerchantInformationStore);
import SnippetStore from "./stores/SnippetStore";
storeConnect.registerStore("SnippetStore", SnippetStore);
import { SitecoreFooterStore } from "./stores/SitecoreFooterStore";
storeConnect.registerStore("SitecoreFooterStore", SitecoreFooterStore);
import { PromptStore } from "./stores/PromptStore";
storeConnect.registerStore("PromptStore", PromptStore);
import CookieLawStore from "./stores/CookieLawStore";
storeConnect.registerStore("CookieLawStore", CookieLawStore);
import PersonalListStore from "./stores/PersonalListStore";
storeConnect.registerStore("PersonalListStore", PersonalListStore);
import PositionRulesStore from "./stores/PositionRulesStore";
storeConnect.registerStore("PositionRulesStore", PositionRulesStore);
import StoreListStore from "./stores/StoreListStore";
storeConnect.registerStore("StoreListStore", StoreListStore);
import StoreListResultStore from "./stores/StoreListResultStore";
storeConnect.registerStore("StoreListResultStore", StoreListResultStore);
import { ArticlesLandingPageStore } from "./stores/ArticlesLandingPageStore";
storeConnect.registerStore("ArticlesLandingPageStore", ArticlesLandingPageStore);
import BannerStore from "./stores/BannerStore";
storeConnect.registerStore("BannerStore", BannerStore);

// Register actions to be used with storeConnect
import MerchantInformationActions from "./actions/MerchantInformationActions";
storeConnect.registerActions("MerchantInformationActions", MerchantInformationActions);
import SitecoreFooterActions from "./actions/SitecoreFooterActions";
storeConnect.registerActions("SitecoreFooterActions", SitecoreFooterActions);
import PromptActions from "./actions/PromptActions";
storeConnect.registerActions("PromptActions", PromptActions);
import CookieLawActions from "./actions/CookieLawActions";
storeConnect.registerActions("CookieLawActions", CookieLawActions);
import ListAction from "./actions/ListAction";
storeConnect.registerActions("ListAction", ListAction);
import CustomerHistoryAction from "./actions/CustomerHistoryAction";
storeConnect.registerActions("CustomerHistoryAction", CustomerHistoryAction);

export default storeConnect;
export * from "./utils/storeConnect";
